import { render } from "./PagoEnBanco.vue?vue&type=template&id=cfbeebf0"
import script from "./PagoEnBanco.vue?vue&type=script&lang=js"
export * from "./PagoEnBanco.vue?vue&type=script&lang=js"

import "./PagoEnBanco.vue?vue&type=style&index=0&id=cfbeebf0&lang=scss"

import exportComponent from "C:\\Users\\jenkins\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\Predial-UI-PRD\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__